import React from "react";
import { useLang } from "../LangContext";
import { useContact } from "../ContactContext";
import { Instagram, Facebook, Youtube, Mail } from "lucide-react";
import { LOGO_URL } from "../assets/brand";

export const Footer = () => {
  const { t } = useLang();
  const { openContact } = useContact();
  const year = new Date().getFullYear();

  return (
    <footer
      id="footer"
      data-testid="footer"
      className="relative pt-20 pb-10 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-2xl overflow-hidden bg-white shadow-lg shadow-fuchsia-500/30 ring-1 ring-white/20">
                <img
                  src={LOGO_URL}
                  alt="Bac à jeux"
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="font-display text-2xl font-extrabold">
                Bac à jeux
              </span>
            </div>
            <p className="mt-5 text-slate-400 max-w-md leading-relaxed">
              {t.footer.tagline}. {t.footer.city}.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[Instagram, Facebook, Youtube, Mail].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label={`social-${i}`}
                  className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-slate-300 hover:text-white hover:bg-white/10 transition"
                  data-testid={`footer-social-${i}`}
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.3em] font-bold text-fuchsia-200/80">
              Navigation
            </div>
            <ul className="mt-4 space-y-2.5">
              {[
                ["#mission", t.nav.mission],
                ["#universes", t.nav.universes],
                ["#follow-me", t.nav.followMe],
                ["#founders", t.nav.founders],
                ["#upcoming", t.nav.upcoming],
              ].map(([href, label]) => (
                <li key={href}>
                  <a
                    href={href}
                    className="text-slate-300 hover:text-white transition"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.3em] font-bold text-fuchsia-200/80">
              {t.footer.contact}
            </div>
            <div className="mt-4 space-y-4 text-slate-300">
              <button
                type="button"
                onClick={() => openContact()}
                className="inline-flex items-center gap-2 rounded-full bg-white/5 hover:bg-white/10 border border-white/15 hover:border-white/30 px-4 py-2.5 text-sm font-semibold text-white transition"
                data-testid="footer-contact-btn"
              >
                <Mail className="w-4 h-4" />
                {t.footer.contactValue}
              </button>
              <p className="text-sm">
                <span className="text-slate-500">{t.footer.social} :</span>{" "}
                {t.footer.socialValue}
              </p>
              <p className="text-sm">
                <span className="text-slate-500">Localisation :</span>{" "}
                {t.footer.city}
              </p>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-slate-500">
          <span>
            © {year} Bac à jeux — {t.footer.rights}
          </span>
          <span className="font-mono uppercase tracking-[0.25em]">
            Made with ♠ in Poissy
          </span>
        </div>
      </div>
    </footer>
  );
};
